import styled from 'styled-components'

interface IWrapper {
  color: string
}

export const Wrapper = styled.div<IWrapper>`
  > input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  label {
    width: 100%;
    margin-bottom: 0;
    cursor: pointer;
    div {
      background-color: ${(props) => props.color};
      width: 24px;
      height: 24px;
      position: absolute;
      border-radius: 50%;
      z-index: 1;
      margin-top: 8px;
      margin-left: 10px;
      pointer-events: none;
    }
    input {
      pointer-events: none;
      padding-left: 38px;
    }
    .ant-input-suffix {
      color: #757575;
    }
  }
`
